import { gql } from '@apollo/client';

export const GET_DICTIONARIES = gql`
  query GetDictionaries {
    inspection_category_types {
      id
      name
    }
    inspection_log_data_types {
      id
      name
    }
    welding_consumables {
      id
      name
    }
  }
`;
